import React, { HTMLAttributes, HTMLProps, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import {
  DOMAIN_JELLINEK_ZELFHULP,
  FEATURE_FLAGS,
  ROUTE_TYPE_GUIDED_SELF_HELP,
} from '../../../config/constants';
import { CoreLink } from '../../../components';
import useRoutes from '../../../hooks/useRoutes';
import MenuContent from './Content';
import MenuTool from './Tool';

import './style.scss';

const MenuMain: React.FC<HTMLProps<HTMLAttributes<HTMLMenuElement>>> = ({ className }) => {
  const { t } = useTranslation();
  const { logout } = useRoutes();
  const { clients } = useRoutes(ROUTE_TYPE_GUIDED_SELF_HELP);

  const isLoggedIn = useSelector<ImmutableRootState<boolean>, boolean>((state) => state.getIn(['login', 'loggedIn'], null));
  const currentDomain = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], null));

  return useMemo(() => {
    if (currentDomain === DOMAIN_JELLINEK_ZELFHULP) {
      return null;
    }

    if (FEATURE_FLAGS.zelfhulp_poh && isLoggedIn === true) {
      return (
        <div className="MenuMain__guided-self-help-links">
          <CoreLink to={clients} title={t('buttons.dashboard')} />
          <CoreLink to={logout} title={t('buttons.logout')} />
        </div>
      );
    }

    if (isLoggedIn === false) {
      return <MenuContent className={className} />;
    }

    if (isLoggedIn === true) {
      return <MenuTool className={className} />;
    }

    return null;
  }, [isLoggedIn, currentDomain]);
};

export default MenuMain;
